export default "__VITE_ASSET__CYvTH6Jd__"